import { render } from "./workspaces.vue?vue&type=template&id=c80fc16a"
import script from "./workspaces.vue?vue&type=script&lang=js"
export * from "./workspaces.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__